// src/pages/services/EcommerceApplications.jsx
import React from 'react';
import ServiceTemplate from '../../components/services/ServiceTemplate';
import ecommerceImg from '../../assets/images/expertise.jpg';

const EcommerceApplications = () => {
  const features = [
    {
      icon: '🛒',
      title: 'Seamless Shopping',
      description: 'Intuitive user experience that drives conversions and retention'
    },
    {
      icon: '💳',
      title: 'Secure Payments',
      description: 'Multiple payment gateway integrations with PCI compliance'
    },
    {
      icon: '📱',
      title: 'Mobile Optimized',
      description: 'Responsive design for perfect shopping on any device'
    },
    {
      icon: '📊',
      title: 'Analytics Dashboard',
      description: 'Real-time insights into sales, customers, and behavior'
    },
    {
      icon: '🔌',
      title: 'API Integration',
      description: 'Connect with ERP, CRM, and inventory systems'
    },
    {
      icon: '🚀',
      title: 'Scalable Platform',
      description: 'Handle traffic spikes during peak seasons seamlessly'
    }
  ];

  const benefits = [
    'Deliver seamless shopping experiences that convert',
    'Integrate with existing business processes smoothly',
    'Expand digital market opportunities globally',
    'Mobile-optimized storefronts for on-the-go shopping',
    'Secure payment gateways with fraud protection',
    'Inventory and order management automation'
  ];

  const technologies = [
    { icon: '🛍️', name: 'Shopify Plus' },
    { icon: '🛒', name: 'WooCommerce' },
    { icon: '⚛️', name: 'React/Next.js' },
    { icon: '💳', name: 'Stripe/PayPal' },
    { icon: '📦', name: 'Inventory Mgmt' },
    { icon: '📊', name: 'Google Analytics' },
    { icon: '☁️', name: 'Cloud Hosting' },
    { icon: '🔒', name: 'SSL Security' }
  ];

  const industries = [
    'Retail', 'Manufacturing', 'Food Industry', 'Fashion',
    'Electronics', 'Healthcare', 'B2B Commerce', 'Marketplaces'
  ];

  const process = [
    { title: 'Strategy', description: 'Define requirements and platform selection' },
    { title: 'Design', description: 'Create engaging user experience and interface' },
    { title: 'Development', description: 'Build and integrate all store features' },
    { title: 'Launch', description: 'Deploy, test, and go live with support' }
  ];

  return (
    <ServiceTemplate
      title="Ecommerce Applications"
      badge="ECOMMERCE SOLUTIONS"
      description="Powerful digital commerce platforms that deliver seamless shopping experiences. Expand your market reach and boost sales with our custom ecommerce solutions."
      heroImage={ecommerceImg}
      features={features}
      benefits={benefits}
      technologies={technologies}
      industries={industries}
      process={process}
      ctaText="Launch Your Store"
      ctaLink="/contact"
    />
  );
};

export default EcommerceApplications;